import * as React from 'react';
import css from './ServiceFooterSectionRow.module.scss';

interface Props {
  heading?: string;
  links: Array<{ url: string; text: string }>;
}

const ServiceFooterSectionRow = (props: Props) => {
  return (
    <div className={css.ServiceFooterSectionRow}>
      {props.heading && (
        <div className={css.ServiceFooterSectionRow__Head}>{props.heading}</div>
      )}
      <ul className={css.ServiceFooterSectionRow__BodyList}>
        {props.links.map((link, index) => {
          return (
            <li
              key={index}
              className={
                index !== props.links.length - 1
                  ? css.ServiceFooterSectionRow__BodyListItem
                  : css.ServiceFooterSectionRow__BodyListItemLast
              }
            >
              <a href={link.url}>{link.text}</a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ServiceFooterSectionRow;
